<template>
  <div id="index">
    <div class="header">
      <div class="headerBox">您好，欢迎来到亳药师！&nbsp;&nbsp;<a v-show="showLogin" @click="goLogin">请登录</a>&nbsp;&nbsp;<a  v-show="showLogin" @click="goRegister">免费注册</a></div>
    </div>
    <div class="search">
      <div class="searchBox">
        <img src="../assets/img/logo.png" @click="goIndex" alt="亳药师" >
        <input v-model="searchText" />
        <button type="primary" @click="search"><img src="../assets/img/searchIcon.png" alt="搜索">搜索</button>
        <p @click="showEWM"  v-show="EWMButton"><img src="../assets/img/mobileIcon.png" alt="关注公众号"> 关注公众号</p>
        <img v-show="EWMImg" @click="showButton" src="../assets/img/footerImg.jpg" alt="关注公众号" class="EWMImg">
      </div>
    </div>
    <div class="index1">
      <div class="index1Box">
        <div class="index1Left">
          <h4><img src="../assets/img/menuIcon.png" alt="">所有产品分类</h4>
          <ul>
            <li v-for="(item,index) in grouplist" :key="index" :class="activeClass == index ? 'indexProductActive':''"  @mouseenter="showTwoProduct(item,index)" @mouseleave="hideTwoProduct(item,index)">
            <img :src="item.img" ref="imgSrc">{{item.name}}+
              <!-- <h6><img :src="item.img" >{{item.name}}+</h6> -->
              <!-- <p>
                <a v-for="item1 in item.alist" :key="item1.id" @click="goProductList(item1.id)">{{item1.varietiesName}}、</a>
              </p> -->
            </li>
          </ul>
          <div class="index1LeftProduct" v-show="showProduct" v-for="(item,index) in twoGrouplist" :key="index"  @mouseenter="showTwoProductDiv(item)">
            <div class="">
              <h5><b @click="changeA(item,$event)">A</b><b @click="changeA(item,$event)">B</b><b @click="changeA(item,$event)">C</b><b @click="changeA(item,$event)">D</b><b @click="changeA(item,$event)">E</b><b @click="changeA(item,$event)">F</b></h5>
              <p><a v-for="item1 in item.alist" :key="item1.id" :class="item1.firstLetter == onA ? 'index1LeftProductP':''" @click="goProductList(item1.id)">{{item1.varietiesName}}、</a></p>
            </div>
            <div class="">
              <h5><b @click="changeA(item,$event)">G</b><b @click="changeA(item,$event)">H</b><b @click="changeA(item,$event)">I</b><b @click="changeA(item,$event)">J</b><b @click="changeA(item,$event)">K</b><b @click="changeA(item,$event)">L</b></h5>
              <p><a v-for="item1 in item.blist" :key="item1.id" :class="item1.firstLetter == onA ? 'index1LeftProductP':''"  @click="goProductList(item1.id)">{{item1.varietiesName}}、</a></p>
            </div>
            <div class="">
              <h5><b @click="changeA(item,$event)">M</b><b @click="changeA(item,$event)">N</b><b @click="changeA(item,$event)">O</b><b @click="changeA(item,$event)">P</b><b @click="changeA(item,$event)">Q</b><b @click="changeA(item,$event)">R</b><b @click="changeA(item,$event)">S</b></h5>
              <p><a v-for="item1 in item.clist" :key="item1.id" :class="item1.firstLetter == onA ? 'index1LeftProductP':''" @click="goProductList(item1.id)">{{item1.varietiesName}}、</a></p>
            </div>
            <div class="">
              <h5><b @click="changeA(item,$event)">T</b><b @click="changeA(item,$event)">U</b><b @click="changeA(item,$event)">V</b><b @click="changeA(item,$event)">W</b><b @click="changeA(item,$event)">X</b><b @click="changeA(item,$event)">Y</b><b @click="changeA(item,$event)">Z</b></h5>
              <p><a v-for="item1 in item.dlist" :key="item1.id" :class="item1.firstLetter == onA ? 'index1LeftProductP':''"  @click="goProductList(item1.id)">{{item1.varietiesName}}、</a></p>
            </div>
          </div>
        </div>
        <div class="index1Right">
          <ul class="index1RightNav">
            <li :class="navActiveClass == index ? 'navActive':''" v-for="(item,index) in navList" :key="index" @click="goNav(item.go,index)">{{item.name}}</li>
            <!-- <li class="navActive" @click="goIndex">首页</li>
            <li @click="goOfferList">推荐资源</li>
            <li @click="goDynamicsList">药材交易动态</li>
            <li @click="goNewslist">药材资讯</li>
            <li @click="goProductList">自营产品</li> -->
          </ul>
          <div class="index1RightBanner">
            <el-carousel indicator-position="none" :interval="5000" arrow="always" >
              <!-- <el-carousel-item v-for="item in bannerlist" :key="item.id" style="height:421px">
                <img :src="item.imageUrl" alt="">
              </el-carousel-item> -->
              <el-carousel-item style="height:421px">
          <img src="../assets/img/banner2.png">
        </el-carousel-item>
        <el-carousel-item style="height:421px">
          <img src="../assets/img/banner1.png">
        </el-carousel-item>
            </el-carousel>
          </div>
          <div class="index1RightLogin">
            <h5 v-show="showLogin"><button @click="goLogin">登录</button><button @click="goRegister">注册</button></h5>
            <h5 v-show="showAfterLogin" class="afterLogin"><img src="../assets/img/indexIcon7.png" alt="">欢迎来到亳药师</h5>
            <!-- <el-tabs type="border-card">
              <el-tab-pane label="我是买家">
                <ul class="index1LoginUl">
                  <li><img src="../assets/img/indexIcon1.png" alt="发布采购"><p>发布采购</p></li>
                  <li><img src="../assets/img/indexIcon2.png" alt="采购管理"><p>采购管理</p></li>
                  <li><img src="../assets/img/indexIcon3.png" alt="订单管理"><p>订单管理</p></li>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="我是卖家">
                 <ul class="index1LoginUl">
                  <li><img src="../assets/img/indexIcon4.png" alt="去报价"><p>去报价</p></li>
                  <li><img src="../assets/img/indexIcon5.png" alt="发布商品"><p>发布商品</p></li>
                  <li><img src="../assets/img/indexIcon6.png" alt="商品订单"><p>商品订单</p></li>
                </ul>
              </el-tab-pane>
            </el-tabs>-->
            <h6>公告信息</h6>

            <!-- <vue-seamless-scroll :data="articleList" class="seamless-warp"  :class-option="classOptiona"> -->
            <vue-seamless-scroll :data="articleList" class="seamless-warp" :class-option="defaultOption" >
              <ul class="index1LoginGG">
                <li v-for="item in articleList" :key="item.id" @click="goNewsDetails(item.id)"><span>•</span>{{item.articleTitle}}<b>{{item.createTime}}</b></li>
              </ul>
            </vue-seamless-scroll>
            <img src="../assets/img/index1RightImg.png" alt=""></img>
          </div>
        </div>
      </div>
    </div>
    <div v-show="searchDiv" style="margin-top: 20px;">
      <!-- 推荐产品 -->
      <div class="index5 productList" >
        <div class="index5Box productListBox">
          <!-- 报价搜索 -->
          <!-- <div class="offerSearch">
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input2"></el-input>
            <button type="primary">搜索</button>
          </div> -->
          <ul>
            <li v-for="item in searchList" :key="item.id"  @click="goProductDetails(item.id)">
              <img :src="item.images" />
              <p>{{item.goodName}}&nbsp;{{item.chandi}}</p>
              <p><span>价格电议</span> </p>
            </li>
          </ul>
        </div>
        <div class="pageBox">
          <el-pagination background layout="prev, pager, next" :currentPage="currentPage" :pageSize ="pageSize" :total="totalNum"  @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
      <div class="footer">
        <div class="foot">
          <ul>
            <li>电话：0558-5858131</li>
            <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
<<<<<<< HEAD
            <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
            <li>皖公网安备 3416020200060号</li>
=======
            <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 <a rel="nofollow" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">皖ICP备18026442号-1</a></li>
            <li><a rel="nofollow" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34160202000600" target="_blank">皖公网安备 34160202000600号</a></li>
>>>>>>> 1b4e74a89da3afb06d391200fd93e189d6f6a38f
          </ul>
          <img src="../assets/img/footerImg.jpg" alt="">
        </div>
      </div>
    </div>
    <div v-show="indexDiv">

    <div class="index2">
      <div>
        <img src="../assets/img/index2Img.png" alt="买药材 找我们" />
      </div>
    </div>
    <!-- 推荐资源、 -->
    <div class="index3">
      <div class="index3Box">
        <div class="index3Left">
          <h2>
            <b>&nbsp;&nbsp;推荐资源</b>
            <!-- <ul class="index3Title">
              <li v-for="item in 6" :key="item">安***公司成功发布1条求购信息</li>
            </ul> -->
            <a @click="goOfferList">更多询盘</a>
          </h2>
          <div class="index3ZY">
            <el-carousel :interval="5000" arrow="always">
              <el-carousel-item v-for="item in demandList" :key="item.id">
                <ul class="index3ZYDom">
                  <li v-for="item in demandList" :key="item.id">

                    <h5>品种：{{item.verietiesName}} <span>规格：{{item.skuName}}</span></h5>
                    <!-- <h6>采购量：{{item.goodName}} <span>已有报价<u>2</u>条</span></h6> -->
                    <h6>采购量：{{item.total}}{{item.unit}}</h6>
                    <p>采购单位：{{item.companyName}}</p>
                    <p class="index3ZYDomText">质量要求：{{item.requirements}}</p>
                    <p>截至报价时间：{{item.realseTime}}</p>
                    <el-button type="warning" @click="goOfferDetails(item.id)">立即报价</el-button>
                  </li>
                </ul>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="index3Right">
          <div>
            <h3>推荐资源</h3>
            <h4>帮助提升互联网采购能力</h4>
            <ul>
              <li>
                <span>7030</span>
                <span>推荐资源</span>
              </li>
              <li>
                <span>9020</span>
                <span>供应商报价</span>
              </li>
            </ul>
            <img src="../assets/img/index3Img.png" alt="">
            <p>扫一扫，手机报价</p>
          </div>
        </div>
      </div>
    </div>
    <div class="index4">
      <div class="index4Box">
        <div class="index4Left">
          <h2><b>&nbsp;&nbsp;药材交易动态</b></h2>
          <!-- <iframe src="http://119.18.207.73:16908/uic-front/front/app/uic/hq/hqV_xg.jsp"  width="635px" height="100%" style="margin:10px 0 10px 20px;border:none;" ></iframe> -->
          <div class="index4Tab">
            <div class="index4TabMore" @click="goDynamicsList">更多</div>
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="市场价格" name="first">
                <table class="jgTable">
                  <thead>
                    <td v-for="(item,tdIndex) in jgList" :class="jgActiveClass == tdIndex ? 'tableActive':''"  @click="changeJG(tdIndex,item.id)"><a>{{item.name}}</a></td>
                  </thead>
                  <tr><td><u>品名</u></td><td><u>规格</u></td><td><u>价格</u></td><td><u>走势</u></td></tr>
                  <tr v-for="item in dynamicsList" :key="item.id"><td>{{item.ycnam}}</td><td>{{item.guige}}</td><td><b>￥{{item.pri}}</b></td><td>{{item.zoushi}}</td></tr>
                </table>
              </el-tab-pane>
              <el-tab-pane label="涨跌幅榜" name="second">
                <table class="zftable">
                  <thead>
                    <td v-for="(item,zfTdIndex) in dynamicsTimeList" :key="zfTdIndex" :class="zfActiveClass == zfTdIndex ? 'tableActive':''" @click="changeZF(item.id,zfTdIndex)"><a >{{item.name}}</a></td>
                  </thead>
                  <tr><td><u>品名</u></td><td><u>规格</u></td><td><u>产地</u></td><td><u>价格</u></td><td><u>涨幅</u></td></tr>
                  <tr v-for="item in dynamicsList" :key="item.id"><td>{{item.ycnam}}</td><td>{{item.guige}}</td><td>{{item.chandi}}</td><td><b>￥{{item.pri}}</b></td><td>{{item.zoushi}}</td></tr>
                </table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="index4Right">
          <h2><b>&nbsp;&nbsp;新闻资讯</b><a @click="goNewslist">更多</a></h2>
          <ul class="index4RightZX">
            <li v-for="item in newsList" :key="item.id" @click="goNewsDetails(item.id)"><span>•</span>{{item.articleTitle}}<b>{{item.createTime}}</b></li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 推荐产品 -->
    <div class="index5">
      <div class="index5Box" style="width:1220px">
        <h2><b>&nbsp;&nbsp;推荐产品</b><router-link to='/ProductList'><a>更多</a></router-link></h2>
        <ul>
          <li v-for="(item, index) in goodsList" :key="item.id">
            <img :src="item.images"  @click="goProductDetails(item.id)"/>
            <p @click="goProductDetails(item.id)">{{item.goodName}}&nbsp;{{item.chandi}}</p>
            <p v-show="goodsShowIndex != index"><button @click="showPhone(index)">价格电议</button></p>
            <p class="index5BoxPhoneP" v-show="goodsShowIndex == index">{{item.phone}}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div id="index6" class="index6">
      <div class="index6Box">
        <h2><b>&nbsp;&nbsp;合作伙伴</b></h2>
        <!-- <img src="../assets/img/partner1.png" />
        <img src="../assets/img/partner2.png" />
        <img src="../assets/img/partner3.png" />
        <img src="../assets/img/partner4.png" />
        <img src="../assets/img/partner5.png" /> -->
        <ul>
          <li v-for="itemqq in aboutImgList" :key="itemqq.id"><img :src="itemqq.aboutImgurl" /></li>
        </ul>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="foot">
        <ul>
          <li>电话：0558-5858131</li>
          <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
          <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
          <li>皖公网安备 3416020200060号</li>
        </ul>
        <img src="../assets/img/footerImg.jpg" alt="">
      </div>
    </div>
    </div>
    <Login ref="login"></Login>
    <Register ref="register"></Register>
    <el-dialog :visible.sync="isDialog" width="20%" :before-close="isClose">
      <p>抱歉! 您目前不可以参与报价，请先登录账号信息谢谢。</p>
      <button @click="goLogin" class="isQueren">确定</button>
    </el-dialog>
    <!-- <el-dialog :visible.sync="phoneDialog" width="20%" :before-close="phoneClose">
      <p>{{phone}}</p>
    </el-dialog> -->
  </div>
</template>
<script>
import Login from '../components/login'
import Register from '../components/register'
import vueSeamlessScroll from 'vue-seamless-scroll'
import commands from 'shelljs/commands'
export default {
  components: {
    Login,
    Register,
    vueSeamlessScroll
  },
  data() {
     return {
      isDialog:false,
      phoneDialog:false,
      phone:'',
      searchText:'',
      searchDiv:false,
      searchList:[],
      navActiveClass:0,
      activeClass: -1, 	// 0为默认选择第一个，-1为不选择
      activeName:'first',
      jgActiveClass:0,
      zfActiveClass:0,
      tdIndex:0,
      zfTdIndex:0,
      jgList:[
        {id:"1",name:'亳州药市'},
        {id:"2",name:'安国药市'},
        {id:"3",name:'玉林药市'},
        {id:"4",name:'荷花池药市'}
      ],
      showLogin:true,
      showAfterLogin:false,
      demandList:[],//资源
      grouplist:[],//分类
      twoGrouplist:[],//二级分类
      bannerlist:[],//轮播图片
      articleList:[],//公告
      newsList:[],//新闻
      dynamicsList:[],
      EWMImg:false,
      EWMButton:true,
      loginDialog: false,
      registerDialog:false,
      checked:false,
      showProduct:false,
      goodsList:[],
      goodsShowIndex: -1,
      aboutImgList:[
        {id:"000",aboutImgurl:require('../assets/img/partner6.png')},
        {id:"001",aboutImgurl:require('../assets/img/partner7.png')},
        {id:"002",aboutImgurl:require('../assets/img/partner8.png')},
      ],
      searchDiv:false,
      indexDiv:true,
      currentPage: 1,//默认显示第一页
      pageSize:10,//默认每页显示10条
      totalNum: 100, //总页数
      bindtop:false,
      onA:'',
      dynamicsTimeList:[
        {id:'yesterday',name:'日'},
        {id:'zhouduibi',name:'周'},
        {id:'yueduibi',name:'月'},
        {id:'jiduibi',name:'季'},
        {id:'nianduibi',name:'年'},
      ],
      navList:[
        {go:'Index',name:'首页'},
        {go:'OfferList',name:'推荐资源'},
        {go:'DynamicsList',name:'药材交易动态'},
        {go:'NewsList',name:'新闻资讯'},
        {go:'ProductList',name:'自营产品'}
      ]
    }
  },
  computed:{
    defaultOption () {
        return {
            step: 0.1, // 数值越大速度滚动越快
            limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
            hoverStop: true, // 是否开启鼠标悬停stop
            direction: 1, // 0向下 1向上 2向左 3向右
            openWatch: true, // 开启数据实时监控刷新dom
            singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
            singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
            waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
        }
    }
  },
  mounted() {
    this.activeClass = this.$cookie.get('navIndex')
    if(this.$cookie.get('account') == null){
      this.showLogin = true
      this.showAfterLogin = false
    }else{
      this.showLogin = false
      this.showAfterLogin = true
    }
    this.getDemandInfoList();
    this.getGoodsList();
    this.getGroupList();
    this.getBannerImgList();
    this.getArticleList();
    this.getNewsList();
    this.getDynamicsList();
  },
  methods: {
    search(){
      this.$fetch('getSearchList',{goodName:this.searchText,pageNo:this.currentPage,pageSize:this.pageSize}).then(res => {
        this.searchList = res.result.records;
        this.totalNum = res.result.total;
        this.searchDiv = true;
        this.indexDiv = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;    //动态改变
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //资源列表
    getDemandInfoList(){
      this.$fetch('getDemandInfoList').then(res => {
        this.demandList = res.result.records;
      })
    },
    //产品
    getGoodsList(){
      this.$fetch('getGoodsList',{recommend: 'Y',pageNo:1,pageSize:10}).then(res => {
        this.goodsList = res.result.records;
      })
    },
    //分类
    getGroupList(){
      this.$fetch('getGroupList').then(res => {
        this.grouplist = res.result;
      })
    },
    //轮播图片
    getBannerImgList() {
      this.$fetch('getBannerImgList').then(res => {
        this.bannerlist = res.result.records;
      })
    },
    //公告
    getArticleList() {
      this.$fetch('getArticleList',{articleType: "1",pageNo: 1,pageSize: 10}).then(res => {
        this.articleList = res.result.records;
      })
    },
    //新闻
    getNewsList() {
      this.$fetch('getArticleList',{articleType: "2",pageNo: 1,pageSize: 10}).then(res => {
        this.newsList = res.result.records;
      })
    },
    // 药材交易动态 切换
    handleClick(tab, event) {
    },
    // 药材交易动态
    getDynamicsList(){
      this.$fetch('getDynamicsList',{market:1}).then(res => {
        this.dynamicsList = res.result.records;
      })
    },
    //市场价格 切换
    changeJG(tdIndex,id){
      this.jgActiveClass = tdIndex;
      this.$fetch('getDynamicsList',{market:id}).then(res => {
        this.dynamicsList = res.result.records;
      })
    },
    //点涨幅榜 切换
    changeZF(id,index){
      this.zfActiveClass = index;
      this.$fetch('getDynamicsList',{paramName:id}).then(res => {
        this.dynamicsList = res.result.records;
      })
    },
    // 点击显示二维码
    showEWM(){
      this.EWMImg = true;
      this.EWMButton = false
    },
    // 点击显示二级药材
    showTwoProduct(data,index){
      if(this.showProduct == true){
        this.showProduct = false;

      }else{
        this.showProduct = true;
        this.$refs.imgSrc[index].src = this.grouplist[index].checkImg
        this.twoGrouplist = [JSON.parse(JSON.stringify(data))];
        this.activeClass = index
      }
    },
    hideTwoProduct(data,index){
      this.showProduct = false;
      this.$refs.imgSrc[index].src = this.grouplist[index].img
      this.onA = ''
    },
    showTwoProductDiv(){
      this.showProduct = true
    },
    // 首字母选择
    changeA(data,event){
      if(event.target.innerText == 'A' || event.target.innerText == 'B' || event.target.innerText == 'C' || event.target.innerText == 'D' || event.target.innerText == 'F' ){
        for(var i=0;i<data.alist.length;i++){
          if(data.alist[i].firstLetter == event.target.innerText){
            this.onA = event.target.innerText
          }
        }
      }
      if(event.target.innerText == 'G' || event.target.innerText == 'H' || event.target.innerText == 'I' || event.target.innerText == 'J' || event.target.innerText == 'K' || event.target.innerText == 'L' ){
        for(var i=0;i<data.blist.length;i++){
          if(data.blist[i].firstLetter == event.target.innerText){
            this.onA = event.target.innerText
          }
        }
      }
      if(event.target.innerText == 'M' || event.target.innerText == 'N' || event.target.innerText == 'O' || event.target.innerText == 'P' || event.target.innerText == 'Q' || event.target.innerText == 'R' || event.target.innerText == 'S'){
        for(var i=0;i<data.clist.length;i++){
          if(data.clist[i].firstLetter == event.target.innerText){
            this.onA = event.target.innerText
          }
        }
      }
      if(event.target.innerText == 'T' || event.target.innerText == 'U' || event.target.innerText == 'V' || event.target.innerText == 'W' || event.target.innerText == 'X' || event.target.innerText == 'Y' || event.target.innerText == 'Z'){
        for(var i=0;i<data.dlist.length;i++){
          if(data.dlist[i].firstLetter == event.target.innerText){
            this.onA = event.target.innerText
          }
        }
      }
    },
    // 点击显示关注按钮
    showButton(){
      this.EWMImg = false;
      this.EWMButton = true;
    },
    goLogin(){
      this.isDialog = false;
      this.$refs.login.toLogin();
    },
    goRegister(){
      this.$refs.register.toRegister();
    },
    goIndex(){
      this.$router.push({path:'/'})
    },
    goProductList(id){
      if(id != '' || id != null){
        this.$router.push({name:'ProductList',query: {groupId:id}})
      }else{
        this.$router.push('/ProductList')
      }
    },
    goNewslist(){
      this.$router.push('/NewsList')
    },
    goOfferList(){
      this.$router.push('/OfferList')
    },
    goDynamicsList(){
      if(this.activeName == 'first'){
        this.$router.push('/DynamicsList')
      }else{
        this.$router.push('/UpanddownList')
      }
    },
    //跳转产品详情
    goProductDetails(id){
      this.$router.push({name:'ProductDetails',query: {id:id}})
    },
    goNewsDetails(id){
      this.$router.push({name:'NewsDetails',query: {id:id}})
    },
    goOfferDetails(id){
      console.log("goOfferDetails",id,this.$cookie.get('account'))
      // this.$router.push({name:'OfferDetails',query: {id:id}})
      if(this.$cookie.get('account') == null){
        this.isDialog = true
      }else{
        this.$router.push({name:'OfferDetails',query: {id:id}})
      }
    },
    isClose(){
      this.isDialog = false
    },
    showPhone(index){
      this.goodsShowIndex = index;
    },
    // phoneClose(){
    //   this.phoneDialog = false
    // },
    goNav(go,index){
      this.$cookie.set('navIndex',index);
      this.$router.push(go)
    },
  }
}
</script>
<style>
  @import "../assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/components/index.vue